import { render } from "./ExternalTransactions.vue?vue&type=template&id=0edf9052&scoped=true&ts=true"
import script from "./ExternalTransactions.vue?vue&type=script&lang=ts"
export * from "./ExternalTransactions.vue?vue&type=script&lang=ts"

import "./ExternalTransactions.vue?vue&type=style&index=0&id=0edf9052&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edf9052"]])

export default __exports__